import { api } from '../axios.helper';
import { Config } from '@ecdlink/core';
import {
  VisitBackReferralModelInput,
  VisitDataStatus,
  VisitDataStatusFilterInput,
} from '@ecdlink/graphql';

class Referral {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getReferralsForInfant(
    id: string,
    visitId: string
  ): Promise<VisitDataStatus[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { referralsForInfant: VisitDataStatus[] };
      errors?: {};
    }>(``, {
      id: 'GetReferralsForInfant',
      variables: {
        id,
        visitId,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Get Referrals For Infant Failed - Server connection error'
      );
    }

    return response.data.data.referralsForInfant;
  }

  async getReferralsForVisitId(visitId: string): Promise<VisitDataStatus[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { referralsForVisitId: VisitDataStatus[] };
      errors?: {};
    }>(``, {
      id: 'GetReferralsForVisitId',
      variables: {
        visitId,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Get Referrals For Infant Failed - Server connection error'
      );
    }

    return response.data.data.referralsForVisitId;
  }

  async updateVisitDataStatus(
    input: VisitDataStatusFilterInput[]
  ): Promise<{}> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: {};
      errors?: {};
    }>(``, {
      id: 'UpdateVisitDataStatus',
      variables: {
        input: { referrals: input },
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Update Visit Data Status Failed - Server connection error'
      );
    }
    return response.data.data;
  }

  async getCompletedReferralsForInfant(
    id: string,
    visitId: string
  ): Promise<VisitDataStatus[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { completedReferralsForInfant: VisitDataStatus[] };
      errors?: {};
    }>(``, {
      id: 'GetCompletedReferralsForInfant',
      variables: {
        id,
        visitId,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Get Referrals For Infant Failed - Server connection error'
      );
    }
    return response.data.data.completedReferralsForInfant;
  }

  async getReferralsForMother(
    id: string,
    visitId: string
  ): Promise<VisitDataStatus[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { referralsForMother: VisitDataStatus[] };
      errors?: {};
    }>(``, {
      id: 'GetReferralsForMother',
      variables: {
        id,
        visitId,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Get Referrals For Mother Failed - Server connection error'
      );
    }

    return response.data.data.referralsForMother;
  }

  async getCompletedReferralsForMother(
    id: string,
    visitId: string
  ): Promise<VisitDataStatus[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { completedReferralsForMother: VisitDataStatus[] };
      errors?: {};
    }>(``, {
      id: 'GetCompletedReferralsForMother',
      variables: {
        id,
        visitId,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Get Completed Referrals For Mother Failed - Server connection error'
      );
    }
    return response.data.data.completedReferralsForMother;
  }

  async addVisitBackReferral(input: VisitBackReferralModelInput): Promise<{}> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: {};
      errors?: {};
    }>(``, {
      id: 'AddVisitBackReferral',
      variables: {
        input,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error(
        'Add Visit Back Referral Data Status Failed - Server connection error'
      );
    }
    return response.data.data;
  }
}

export default Referral;
